<template>
  <v-group
    ref="group"
    :config="quoteGroupConfig"
    @click="onGroupClick"
    @tap="onGroupClick"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut" >
    <v-text :config="textConfig"></v-text>
  </v-group>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    x: {},
    y: {},
    offsetX: {
      default: 0
    },
    offsetY: {
      default: 0
    },
    editable: {},
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters("user", [
      "userData"
    ]),

    ...mapGetters("calendar", [
      "random_quote"
    ]),

    quote() {
      // TODO: When user logs out param becomes undefined
      return this.random_quote(this.userData.selectedIdols);
    },

    quoteGroupConfig() {
      return {
        x: this.x,
        y: this.y,
        offsetX: this.offsetX,
        offsetY: this.offsetY,
      };
    },
    textConfig() {
      return {
        draggable: this.editable,
        fill:      'white',
        offsetX:   0,
        offsetY:   0,
        width:     250,
        align:     'center',
        fontSize:  14,
        text:      `${this.quote.quote}\n— ${this.quote.name}`,
      }
    }
  },
  methods: {
    start() {
    },
    onGroupClick(event) {
      let node = this.$refs.group.getNode();
      this.$emit('select', {
        type: 'quote',
        node,
      })
    },
    onMouseOver(event) {
      document.body.style.cursor = 'pointer';
    },
    onMouseOut(event) {
      document.body.style.cursor = 'default';
    }
  }
}
</script>
